<template>
  <v-card class="edit-class" flat>
    <div class="band">
      <v-btn
        fab
        small
        color="white"
        outlined
        class="close-button"
        @click="$emit('close-tab')"
      >
        <v-icon dark>close</v-icon>
      </v-btn>
    </div>
    <section class="announcements pa-3">
      <v-row class="mb-2">
        <v-col md="7" cols="12">
          <h2 class="headline">
            Class announcements
          </h2>
          <p>
            Here you can add, edit or delete class announcements
          </p>
        </v-col>
        <v-col md="5" cols="12">
          <v-fade-transition>
            <div class="text-md-right text-center">
              <v-btn color="primary" @click="createNew = !createNew">
                <v-icon left>
                  {{ createNew ? 'close' : 'comment' }}
                </v-icon>
                {{ createNew ? 'cancel' : 'write new announcement' }}
              </v-btn>
            </div>
          </v-fade-transition>
        </v-col>
        <v-col cols="12">
          <v-slide-y-transition class="mb-3">
            <create-announcement
              v-if="createNew"
              :customClass="customClass"
              @createdAnnouncement="createdAnnouncement"
            />
          </v-slide-y-transition>
        </v-col>
        <v-col cols="12">
          <div
            class="line-separator"
            v-for="(announcement, index) in customClass.messages"
            :key="'msg-' + index"
          >
            <edit-announcement :announcement="announcement" />
          </div>
        </v-col>
      </v-row>
    </section>
  </v-card>
</template>

<script>
import CreateAnnouncement from './announcements/CreateAnnouncement'
import EditAnnouncement from './announcements/EditAnnouncement'
import { mapGetters } from 'vuex'
import Class from '@/modules/class/models/Class'

export default {
  name: 'CreateEditAnnouncements',
  $_veeValidate: {
    validator: 'new'
  },
  components: {
    CreateAnnouncement,
    EditAnnouncement
  },
  props: {},
  data() {
    return {
      createNew: false,
      deleteDialogConfirmation: false,
      yearLevel: null,
      className: null,
      newClass: false,
      active: -1
    }
  },
  async mounted() {},
  computed: {
    ...mapGetters('entities/classes', ['currentClassId']),
    customClass() {
      if (!this.currentClassId) return {}
      return Class.find(this.currentClassId)
    }
  },
  methods: {
    createdAnnouncement() {
      this.createNew = false
    }
  }
}
</script>

<style lang="scss">
.announcements {
  box-shadow: none;

  .line-separator {
    border-top: solid 1px rgba(0, 0, 0, 0.2);
    padding-top: 20px;
  }

  .close-button {
    position: absolute;
    right: 20px;
    top: 12px;
  }
}
</style>
